// Matte natural surfaces (ground, foliage, grass). three's standard material reflects like a smooth
// dielectric at grazing angles (F90 = 1). Rough, cluttered surfaces — needle litter, gravel, leaves
// — shadow their own grazing reflection, and without that the dark forest floor and branch tops
// looked pale and snowy when seen toward the sun. This keeps F0 at 0.02 and lowers F90 (optionally
// per pixel, e.g. back up where a surface is wet).
import * as THREE from 'three/webgpu';
import { float, specularColor, specularColorBlended, specularF90, vec3 } from 'three/tsl';
import type { Node } from 'three/webgpu';

export class MatteNodeMaterial extends THREE.MeshStandardNodeMaterial {
  /** Grazing reflectance (0…1); 0.2 by default. */
  f90Node: Node<'float'> | null = null;

  override setupSpecular(): void {
    specularColor.assign(vec3(0.02));
    specularColorBlended.assign(vec3(0.02));
    specularF90.assign(this.f90Node ?? float(0.2));
  }
}

/**
 * Scale a material's share of the sky lighting (relative to the scene's). three r186 ignores
 * `envMapIntensity` for `scene.environment`, so WorldView.buildEnvironment gives materials that ask
 * for a scale their own envMap and the scaled intensity.
 */
export function setEnvScale(m: THREE.Material, scale: number): void {
  m.userData.envScale = scale;
}
